import createVueComponent from '../createVueComponent';
var Bookmark = createVueComponent('BookmarkIcon', [['path', {
  d: 'm19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z'
}]]);
export default Bookmark;